import RateOrderWeb from "./web";
import type { RateOrderBlockProps } from "./types";

export function RateOrderWebEditor(props: RateOrderBlockProps) {
  return <RateOrderWeb isEditor {...props} />;
}
